<template>
    <div :class="{'page_content--loading': !reportData}">
      <div class="vx-row justify-end">
        <div class="vx-col">
          <switch-field
            v-model="innerFiltered"
            class="mt-4 mb-4"
            name="フィルター表示"
            label="フィルター表示"
          />
        </div>
      </div>
      <div
        v-if="showFilters"
        class="vx-row justify-end"
      >
        <div
          style="z-index: 9998;"
          class="vx-col"
        >
          <div class="filter">
            <sales-filter
              v-model="selectedBrands"
              class="w-48 mb-1 mr-1"
              :options="brandOptions"
              :no-option-text="salesByBrandFilterNoOptionText"
              placeholder="ブランド"
            />
          </div>
        </div>
      </div>

      <div
        v-if="reportData"
      >
        <div class="mt-8">
          <vx-card class="pb-6">
            <template #actions>
              <vs-button
                @click="onClickDownload('summaryByUserRank')"
              >
                CSVエクスポート
              </vs-button>
            </template>
            <data-table
              :row-data="reportData.summaryByUserRank"
              :column-defs="tableProp.summaryByUserRank.columnDefs"
              :default-col-def="tableProp.summaryByUserRank.defaultColDef"
              :pinned-bottom-row-data="totalRow.summaryByUserRank"
              :getRowStyle="getRowStyle"
              style="height: 535px"
            >
            </data-table>
          </vx-card>
        </div>
  
        <div class="mt-8">
          <vx-card>
            <template #actions>
              <vs-button
                @click="onClickDownload('usersByBrandxUserRank')"
              >
                CSVエクスポート
              </vs-button>
            </template>
            <div class="font-semibold text-right">
              ユーザーランク / ユーザー数
            </div>
            <data-table
              :row-data="reportData.usersByBrandxUserRank"
              :column-defs="tableProp.usersByBrandxUserRank.columnDefs"
              :default-col-def="tableProp.usersByBrandxUserRank.defaultColDef"
              :pinned-bottom-row-data="totalRow.usersByBrandxUserRank"
              :getRowStyle="getRowStyle"
            >
            </data-table>
          </vx-card>
        </div>
  
        <div class="mt-8">
          <vx-card>
            <template #actions>
              <vs-button
                @click="onClickDownload('salesByMonetaryGroupxUserRank')"
              >
                CSVエクスポート
              </vs-button>
            </template>
            <div class="font-semibold text-right">
              ユーザーランク / 売上
            </div>
            <data-table
              :row-data="reportData.salesByMonetaryGroupxUserRank"
              :column-defs="tableProp.salesByMonetaryGroupxUserRank.columnDefs"
              :default-col-def="tableProp.salesByMonetaryGroupxUserRank.defaultColDef"
              style="height: 230px"
            >
            </data-table>
            <paragraph class="my-5 text-sm">累計購買金額 | Low=平均購入金額以下、Medium=平均購入金額の2倍以下、High=平均購入金額の2倍以上
            </paragraph>
          </vx-card>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex'
  import chroma from "chroma-js"
  import DataTable from '@/components/table/DataTable'
  import DateRanges from '@/components/DateRanges'
  import SectionTitle from '@/components/SectionTitle'
  import SalesFilter from '@/components/SalesFilter'
  import SwitchField from '@/components/fields/SwitchField'
  import Paragraph from '@/components/Paragraph'
  import USER_RANK from '@/constants/userRank'
  import { debounce } from '@/utils'
  
  export default {
    components: {
      DataTable,
      DateRanges,
      SalesFilter,
      SectionTitle,
      SwitchField,
      Paragraph
    },
    data () {
      return {
        userRank: Object.values(USER_RANK),
        // フィルター
        selectedBrands: [],
        filtered: false,
        showFilters: false,
        // 表のプロパティ
        tableProp: {
          summaryByUserRank: {},
          usersByBrandxUserRank: {},
          salesByMonetaryGroupxUserRank: {}
        },
        // 総計行
        totalRow: {
          summaryByUserRank: [],
          usersByBrandxUserRank: [],
        },
        // ヒートマップ
        maxValue: {
          summaryByUserRank1: -1,  // ユーザー数
          summaryByUserRank2: -1,  // 売上
          usersByBrandxUserRank: -1,
          salesByMonetaryGroupxUserRank: -1
        },
        colorScale: {
          blue: chroma.scale(['#F4FAFE', '#008AE5']),
          orange: chroma.scale(['#FFF8F3', '#F66D00'])
        },
        // APIのactionとパラメータの対応
        apiParameters: {
          summaryByUserRank: ['filters'],
          usersByBrandxUserRank: ['filters'],
          salesByMonetaryGroupxUserRank: ['filters'],
          salesByBrand: [],
        }
      }
    },
    computed: {
      ...mapState('amcRfm', ['requestingStatus', 'reportData', 'filterOptions']),
      ...mapState('account', ['activeAccount']),
      salesByBrandFilterNoOptionText () {
        return this.requestingStatus.salesByBrand ? 'Loading...' : '候補がありません'
      },
      brandOptions () {
        if (!this.reportData) {
          return []
        }
        return this.reportData.salesByBrand.map(item => ({
          text: item.brand,
          value: item.brand,
          sales: item.sales
        }))
      },
      selectedBrandValues () {
        return this.selectedBrands.map(selectedBrand => selectedBrand.value)
      },
      innerFiltered: {
        get () {
          return this.filtered
        },
        set (val) {
          this.filtered = val
          this.showFilters = val
        }
      },
    },
    watch: {
      selectedBrands: {
        handler () {
          this.filterReport()
        },
        deep: true
      },
      activeAccount: {
        handler () {
          this.resetFilters()
        }
      },
      maxValue: {
        handler () {
          this.generateSummaryByUserRankTableProp()
          this.generateUsersByBrandxUserRankTableProp()
          this.generateSalesByMonetaryGroupxUserRankTableProp()
        },
        deep: true
      }
    },
    created () {
      this.getReport()
    },
    methods: {
      ...mapActions('amcRfm', ['fetchReport', 'downloadCSV']),
      resetFilters () {
        this.selectedBrands = []
      },
      findMaxValues() {
        this.maxValue['summaryByUserRank1'] = -1
        if(this.reportData.summaryByUserRank.length > 0) {
          this.reportData.summaryByUserRank.map((row) => {
            for (const [key, value] of Object.entries(row)) {
              if(key === 'users' && value > this.maxValue['summaryByUserRank1']) {
                this.maxValue['summaryByUserRank1'] = value
              }
            }
          })
        }
        this.maxValue['summaryByUserRank2'] = -1
        if(this.reportData.summaryByUserRank.length > 0) {
          this.reportData.summaryByUserRank.map((row) => {
            for (const [key, value] of Object.entries(row)) {
              if(key === 'sales' && value > this.maxValue['summaryByUserRank2']) {
                this.maxValue['summaryByUserRank2'] = value
              }
            }
          })
        }
  
        this.maxValue['usersByBrandxUserRank'] = -1
        if(this.reportData.usersByBrandxUserRank.length > 0) {
          this.reportData.usersByBrandxUserRank.map((row) => {
            for (const [key, value] of Object.entries(row)) {
              if(key.includes('userRank') && value > this.maxValue['usersByBrandxUserRank']) {
                this.maxValue['usersByBrandxUserRank'] = value
              }
            }
          })
        }
  
        this.maxValue['salesByMonetaryGroupxUserRank'] = -1
        if(this.reportData.salesByMonetaryGroupxUserRank.length > 0) {
          this.reportData.salesByMonetaryGroupxUserRank.map((row) => {
            for (const [key, value] of Object.entries(row)) {
              if(key.includes('userRank') && value > this.maxValue['salesByMonetaryGroupxUserRank']) {
                this.maxValue['salesByMonetaryGroupxUserRank'] = value
              }
            }
          })
        }
      },
      sumByKey(arr, key) {
        return arr.reduce((acc, row) => acc + row[key], 0)
      },
      generateTotalRow() {
        if(this.reportData.summaryByUserRank.length > 0) {
          const targetField = ['users', 'sales']
          const sums = {}
          // 各行の特定のキーの値の総和を計算してオブジェクトに格納する
          targetField.forEach(field => {
            sums[field] = this.sumByKey(this.reportData.summaryByUserRank, field);
          });
          this.totalRow.summaryByUserRank = [{
            userRank: '総計',
            users: sums['users'],
            usersShare: 1,
            sales: sums['sales'],
            salesShare: 1,
          }]
        }
  
        if(this.reportData.usersByBrandxUserRank.length > 0) {
          const targetField = Array.from({ length: 7 }, (_, i) => `userRank${i+1}`)
          const sums = {}
          // 各行の特定のキーの値の総和を計算してオブジェクトに格納する
          targetField.forEach(field => {
            sums[field] = this.sumByKey(this.reportData.usersByBrandxUserRank, field);
          });
          this.totalRow.usersByBrandxUserRank = [{
            brand: '総計',
            ...sums
          }]
        }
      },
      getRowStyle (params) {
        if (params.node.rowPinned) {
          return { fontWeight: "bold" };
        }
      },
      omitDupFormatter(params) {
        // targetFieldの両方の値が上段と一致した場合、表示を抑制するフォーマッター
        const targetField = ['userRank', 'recencyGroup']
        const { node, data, value, api } = params;
        if (node.rowIndex > 0) {
          const dataAbove = api.getDisplayedRowAtIndex(node.rowIndex - 1)['data']
          if(dataAbove[targetField[0]] === data[targetField[0]] && dataAbove[targetField[1]] === data[targetField[1]] ) {
            return ''
          }
        }
        return value
      },
      generateSummaryByUserRankTableProp () {
        this.tableProp.summaryByUserRank = {
          defaultColDef: {
            sortable: false,
            editable: false,
            resizable: false,
            suppressMenu: true
          },
          columnDefs: [
            { headerName: 'ユーザーランク', field: 'userRank', pinned: 'left', valueFormatter: this.omitDupFormatter },
            { headerName: 'リーセンシー', field: 'recencyGroup', pinned: 'left', valueFormatter: this.omitDupFormatter },
            { headerName: 'フリークエンシー', field: 'frequencyGroup', pinned: 'left' },
            { headerName: 'ユーザー数', field: 'users', cellStyle: params => {
              if (params.value > 0 && !params.node.rowPinned) {
                return { backgroundColor: this.colorScale['blue'](params.value / this.maxValue['summaryByUserRank1']) };
              } else {
                return { backgroundColor: 'white' }
              }
            }},
            { headerName: 'ユーザーシェア', field: 'usersShare', percent: true, cellStyle: params => {
              if (params.data['users'] > 0 && !params.node.rowPinned) {
                return { backgroundColor: this.colorScale['blue'](params.data['users'] / this.maxValue['summaryByUserRank1']) };
              } else {
                return { backgroundColor: 'white' }
              }
            }},
            { headerName: '売上', field: 'sales', currency: true, cellStyle: params => {
              if (params.value > 0 && !params.node.rowPinned) {
                return { backgroundColor: this.colorScale['orange'](params.value / this.maxValue['summaryByUserRank2']) };
              } else {
                return { backgroundColor: 'white' }
              }
            }},
            { headerName: '売上シェア', field: 'salesShare', percent: true, cellStyle: params => {
              if (params.data['sales'] > 0 && !params.node.rowPinned) {
                return { backgroundColor: this.colorScale['orange'](params.data['sales'] / this.maxValue['summaryByUserRank2']) };
              } else {
                return { backgroundColor: 'white' }
              }
            }},
          ],
        }
      },
      generateUsersByBrandxUserRankTableProp () {
        const columnDefs = Array.from(this.userRank, (v, i) => { 
        return {
          headerName: v,
          field: `userRank${i+1}`,
          cellStyle: params => {
            if (params.value > 0 && !params.node.rowPinned) {
              return { backgroundColor: this.colorScale['blue'](params.value / this.maxValue['usersByBrandxUserRank']) };
            } else {
              return { backgroundColor: 'white' }
            }
          }
        }
        })
  
        this.tableProp.usersByBrandxUserRank = {
          defaultColDef: {
            sortable: false,
            editable: false,
            resizable: false,
            suppressMenu: true
          },
          columnDefs: [
            { headerName: 'ブランド', field: 'brand', pinned: 'left' },
            ...columnDefs,
          ],
        }
      },
      generateSalesByMonetaryGroupxUserRankTableProp () {
        const columnDefs = Array.from(this.userRank, (v, i) => { 
        return {
          headerName: v,
          field: `userRank${i+1}`,
          currency: true,
          cellStyle: params => {
            if (params.value > 0) {
              return { backgroundColor: this.colorScale['orange'](params.value / this.maxValue['salesByMonetaryGroupxUserRank']) };
            } else {
              return { backgroundColor: 'white' }
            }
          }
        }
        })
  
        this.tableProp.salesByMonetaryGroupxUserRank = {
          defaultColDef: {
            sortable: false,
            editable: false,
            resizable: false,
            suppressMenu: true
          },
          columnDefs: [
            { headerName: '累計購買金額', field: 'monetaryGroup', pinned: 'left' },
            ...columnDefs,
          ],
        }
      },
      generateParams (paramKeys) {
        const params = {}
        if ( paramKeys.includes('filters') ) {
          if (this.selectedBrandValues) {
            params['brand'] = this.selectedBrandValues
          }
        }
        return params
      },
      async onClickDownload (action) {
        const params = this.generateParams(this.apiParameters[action])
        try {
          await this.downloadCSV({...params, action})
        } catch (e) {
          console.log(e)
        }
      },
      filterReport: debounce(function () {
        this.getReport()
      }, 1000),
      async getReport () {  
        const actions = [
          'summaryByUserRank',
          'usersByBrandxUserRank',
          'salesByMonetaryGroupxUserRank',
          'salesByBrand'
        ]
  
        await Promise.all(actions.map(action => {
          return new Promise((resolve) => {
            try {
              resolve(this.fetchReport({
                ...this.generateParams(this.apiParameters[action]),
                action
              }))
            } catch (e) {
              console.log(e)
            }
          })
        }))
  
        // ヒートマップ用に最大値を探索する
        this.findMaxValues()
        // 総計行
        this.generateTotalRow()
      }
    }
  }
  </script>
  
  <style lang="scss">
  .page_content--loading .vx-card {
    min-height: 127.875px;
  }
  </style>
  
  <style>
  .holamundo :deep(.vs-popup) {
    width: 400px;
  }
  div.filter {
      display: flex;
      flex-wrap: wrap;
  }
  .sales-filter .multiselect__tags,
  .sales-filter .multiselect__tags .multiselect__input,
  .sales-filter .multiselect__content-wrapper {
    font-size: 13px;
  }
  </style>
  